const HELMET_ACCENTS = {
  red: { color: "#dc2626", tint: "rgba(220, 38, 38, 0.14)" },
  blue: { color: "#2563eb", tint: "rgba(37, 99, 235, 0.14)" },
  yellow: { color: "#eab308", tint: "rgba(234, 179, 8, 0.16)" },
  white: { color: "#cbd5e1", tint: "rgba(203, 213, 225, 0.16)" },
  neutral: { color: "#94a3b8", tint: "rgba(148, 163, 184, 0.14)" },
};

function normalizeHelmetColor(value) {
  const color = String(value || "").trim().toLowerCase();
  if (["#dc2626", "#ef4444", "red", "r", "röd", "rod"].includes(color)) return "red";
  if (["#1d4ed8", "#2563eb", "#3b82f6", "blue", "b", "blå", "bla"].includes(color)) return "blue";
  if (["#eab308", "#facc15", "yellow", "g", "gul"].includes(color)) return "yellow";
  if (["#ffffff", "#fff", "white", "v", "vit"].includes(color)) return "white";
  return "neutral";
}

export function getHelmetAccentStyle(value) {
  const accent = HELMET_ACCENTS[normalizeHelmetColor(value)];
  return {
    "--native-v3-helmet-accent": accent.color,
    "--native-v3-helmet-tint": accent.tint,
  };
}
